module.exports = __webpack_public_path__ + "static/media/cert-star.0b8616cd.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CourseDetail/cert-star.svg
// module id = 128
// module chunks = 0